import React, { Fragment, forwardRef } from "react";
import Link from "./Link";
import AccessibleText from "./AccessibleText";
import { trackLink } from "utils/analytics";

const mainClass = "help-button";

const handleTriggerAnalytics = (e, analyticsLinkId) => {
	if (analyticsLinkId) {
		const linkId = `${analyticsLinkId}_${
			e.type === "click" ? "CLICK" : "HOVER"
		}`;
		trackLink({ linkId });
	}
};

const Button = forwardRef(
	(
		{
			ariaExpanded = null,
			accessibleText = "",
			children,
			className = "",
			customStyles = false,
			disabled = null,
			link = false,
			linkContent = {},
			onClick = null,
			secondary = false,
			tabIndex = null,
			title,
			style = null,
			analyticsLinkId = null,
			trackHover = false,
			childrenPosition = 1,
		},
		ref
	) => {
		let classes = className;
		if (!customStyles) {
			classes += ` ${mainClass}`;
			classes += ` ${mainClass}--${secondary ? "secondary" : "primary"}`;
			classes += ` ${mainClass}--${link ? "link" : "button"}`;
		}

		const renderButtonContent = () => {
			let text = title;
			if (link && linkContent) {
				text = linkContent.title;
			}

			return (
				<Fragment>
					{childrenPosition === 0 && children}
					{text && (
						<span className={`${mainClass}__gradient`}>
							<span className={`${mainClass}__text`}>{text}</span>
						</span>
					)}
					{childrenPosition === 1 && children}
					{accessibleText && <AccessibleText>{accessibleText}</AccessibleText>}
				</Fragment>
			);
		};

		return link ? (
			<Link
				{...linkContent}
				className={classes}
				role="button"
				handleClick={onClick}
			>
				{renderButtonContent()}
			</Link>
		) : (
			<button
				aria-expanded={ariaExpanded}
				className={classes}
				tabIndex={tabIndex}
				disabled={disabled}
				style={style}
				ref={ref}
				onClick={(e) => {
					handleTriggerAnalytics(e, analyticsLinkId);
					onClick(e);
				}}
				onMouseEnter={(e) => {
					trackHover && handleTriggerAnalytics(e, analyticsLinkId);
				}}
			>
				{renderButtonContent()}
			</button>
		);
	}
);

Button.displayName = "Button";
export default Button;
